module.exports = __webpack_public_path__ + "static/img/dd.5481157a.png";